export const isHttpErrorWithParsedBody = (maybeError: unknown) =>
  typeof maybeError === 'object' &&
  maybeError !== null &&
  'parsedBody' in maybeError;

export const isHttpErrorWithStatus = (maybeError: unknown) =>
  typeof maybeError === 'object' &&
  maybeError !== null &&
  'status' in maybeError;

export const isSessionExpiredError = (error: {
  parsedBody?: { errors?: { type: string }[] };
}): boolean => {
  const errors = error?.parsedBody?.errors;
  return (
    Array.isArray(errors) && errors.some(e => e.type === 'session_expired')
  );
};
